// extracted by mini-css-extract-plugin
export var disclaimer = "job-post-module--disclaimer--VLizF";
export var jobs = "job-post-module--jobs--tEeuZ";